import { render, staticRenderFns } from "./SubmissionsNumber.vue?vue&type=template&id=50480077&"
import script from "./SubmissionsNumber.vue?vue&type=script&lang=js&"
export * from "./SubmissionsNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports